import { render, staticRenderFns } from "./MyNews.vue?vue&type=template&id=f1804bf8&"
import script from "./MyNews.vue?vue&type=script&lang=js&"
export * from "./MyNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\LrGithub\\lr-statics\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f1804bf8')) {
      api.createRecord('f1804bf8', component.options)
    } else {
      api.reload('f1804bf8', component.options)
    }
    module.hot.accept("./MyNews.vue?vue&type=template&id=f1804bf8&", function () {
      api.rerender('f1804bf8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lr/js/vue/components/my-news/MyNews.vue"
export default component.exports